export default {
  modelName: 'factory',
  label: '工廠管理',
  fields: {
    area: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'area',
      requiredField: 'area_sections',
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      },
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    subscription_areas: {
      type: 'multi-layer',
      label: '適用地區',
      rules: 'required',
      modelName: 'subscription_areas',
      requiredField: 'subscription_area_sections',
      getUrl: 'area',
      multiple: true,
      layersSetting: {
        modelName: 'subscription_area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      fields: {
        requiredField: 'subscription_area_sections',
        layersSetting: {
          modelName: 'subscription_area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
        getUrl: 'area',
      },
    },
    subscription_area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    area_info: {
      label: '地區',
      type: 'custom',
      readonly: true,
      getValue(data) {
        if (data.area) {
          return data.area.name;
        } else {
          return '';
        }
      },
    },
    // plan: {
    //   type: 'belongsTo',
    //   label: '選擇方案',
    //   // rules: 'required',
    //   textKey: 'name',
    //   modelName: 'plan',
    // },
    license_type: {
      type: 'belongsTo',
      label: '證照類型',
      rules: 'required',
      textKey: 'name',
      modelName: 'license_type',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '工廠名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 200,
        },
      },
    },
    remark: {
      type: 'textarea',
      label: '備註',
      maxlength: 1000,
    },
    name: {
      type: 'text',
      label: '工廠名稱',
      readonly: true,
    },
    factory: {
      type: 'belongsTo',
      label: '所屬集團',
      textKey: 'name',
      modelName: 'factory',
    },
    system_classes: {
      type: 'hasMany',
      label: '領域',
      textKey: 'name',
      modelName: 'system_class',
      rules: 'required',
      requiredField: 'subscription_areas',
      conditionKeys: [
        {
          fieldName: 'subscription_areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      rules: 'required',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_subclass',
    },
    industry_categories: {
      label: '產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
          type: 'number',
        },
      ],
      getText(data) {
        let resultText = '';
        data.forEach((_data) => {
          if (resultText !== '') {
            resultText += ',';
          }
          resultText += _data.name;
        });
        return resultText;
      },
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'area',
            conditionName: 'area',
            type: 'number',
          },
        ],
      },
    },
    subscription_industry_categories: {
      label: '產業類別',
      type: 'multi-layer',
      modelName: 'subscription_industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'subscription_areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      layersSetting: {
        modelName: 'subscription_industry_categories',
        requiredFieldKey: 'industry_categories',
        search: true,
      },
      fields: {
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'subscription_areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
        layersSetting: {
          modelName: 'subscription_industry_categories',
          requiredFieldKey: 'industry_categories',
          search: true,
        },
      },
    },
    status: {
      type: 'switch',
      label: '開通設定',
      defaultValue: true,
      activeText: '啟用',
      inactiveText: '關閉',
    },
    app: {
      type: 'belongsTo',
      label: '客戶系統管理',
      textKey: 'name',
      modelName: 'app',
      rules: 'required',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    tags: {
      label: '全域標籤設定',
      type: 'hasMany',
      inLocale: true,
      textKey: 'name',
      modelName: 'tag',
      hasCloseChips: true,
      // valueKey: "name"
    },
    address: {
      label: '工廠地址',
      type: 'textarea',
      rules: 'required',
      verifyApi: {
        url: '/factory/address_check',
        postKey: 'address',
        successMessage(data) {
          return `此地址驗證成功！地址：${data.address} (N${data.lat}°, E${data.lng}°)`;
        },
        errorMessage(message) {
          if (message === 'address is not exist.') {
            return '此地址無效，請輸入其他地址';
          } else {
            return '錯誤!';
          }
        },
      },
    },
    start_date: {
      label: '啟用日期',
      type: 'date',
      rules: 'required',
    },
    due_date: {
      label: '到期日期',
      type: 'date',
      rules: 'required',
    },
    uniform_number: {
      label: '統一編號',
      type: 'textarea',
    },
    register_number: {
      label: '登記號碼',
      type: 'textarea',
    },
    attaches: {
      type: 'files',
      label: '附件',
      uploadUrl: '/factory/attach/',
    },
    subscriptions: {
      type: 'multi-select',
      label: '訂閱模組',
      multiple: true,
      getRules: (originData) => {
        return originData.type !== undefined && originData.type === 'subscription-api'
          ? ''
          : 'required';
      },
      items: [
        {
          text: '日常自檢',
          value: 'checklist',
        },
        {
          text: '變動管理',
          value: 'change',
        },
        {
          text: '證照管理',
          value: 'license',
        },
        {
          text: '教育訓練',
          value: 'training',
        },
        {
          text: '風險事件',
          value: 'event',
        },
        {
          text: '稽核管理',
          value: 'audit',
        },
        {
          text: '承攬商管理與進廠管理',
          value: 'contractor',
        },
        {
          text: '集團概況',
          value: 'organization-dashboard-read',
        },
        {
          text: '各廠概況',
          value: 'factory-dashboard-read',
        },
        {
          text: '內規',
          value: 'guideline',
        },
        {
          text: '新訊',
          value: 'announcement',
        },
        {
          text: '看板',
          value: 'board',
        },
        {
          text: '警示',
          value: 'alert',
        },
        {
          text: '任務',
          value: 'task',
        },
        {
          text: 'QRcode',
          value: 'qrcode',
        },
        {
          text: '文件檔案庫',
          value: 'file',
        },
        {
          text: '數量統計',
          value: 'statistic',
        },
        {
          text: '法規',
          value: 'act',
        },
        {
          text: '快報',
          value: 'broadcast',
        },
        {
          text: '概況',
          value: 'dashboard',
        },
        {
          text: '議事',
          value: 'meeting',
        },
        {
          text: '操作記錄',
          value: 'log',
        },
      ],
    },
    max_member_count: {
      type: 'number',
      label: '人員最大數量',
      getRules: (originData) => {
        return originData.type !== undefined && originData.type === 'subscription-api'
          ? ''
          : 'required';
      }
    },
    season_start_month: {
      label: 'Q1 起始月份',
      type: 'select',
      items: [
        {
          text: '1月',
          value: 1,
        },
        {
          text: '2月',
          value: 2,
        },
        {
          text: '3月',
          value: 3,
        },
        {
          text: '4月',
          value: 4,
        },
        {
          text: '5月',
          value: 5,
        },
        {
          text: '6月',
          value: 6,
        },
        {
          text: '7月',
          value: 7,
        },
        {
          text: '8月',
          value: 8,
        },
        {
          text: '9月',
          value: 9,
        },
        {
          text: '10月',
          value: 10,
        },
        {
          text: '11月',
          value: 11,
        },
        {
          text: '12月',
          value: 12,
        },
      ],
      defaultValue: 1,
    },
    custom_season_month_q1: {
      label: 'Q1',
      type: 'custom',
      getValue: (data) => {
        return `${data.season_start_month}月-${(data.season_start_month + 2) %
          12 || 12}月`;
      },
    },
    custom_season_month_q2: {
      label: 'Q2',
      type: 'custom',
      getValue(data) {
        return `${(data.season_start_month + 3) % 12 ||
          12}月-${(data.season_start_month + 5) % 12 || 12}月`;
      },
    },
    custom_season_month_q3: {
      label: 'Q3',
      type: 'custom',
      getValue(data) {
        return `${(data.season_start_month + 6) % 12 ||
          12}月-${(data.season_start_month + 8) % 12 || 12}月`;
      },
    },
    custom_season_month_q4: {
      label: 'Q4',
      type: 'custom',
      getValue(data) {
        return `${(data.season_start_month + 9) % 12 ||
          12}月-${(data.season_start_month + 11) % 12 || 12}月`;
      },
    },
    administrator_name: {
      label: '系統管理員',
      type: 'text',
      placeholder: '請輸入系統管理員名稱',
      getRules: (originData) => {
        return originData.type !== undefined && originData.type === 'subscription-api'
          ? ''
          : 'required';
      }
    },
    administrator_email: {
      label: '系統管理員帳號/email',
      type: 'email',
      autocomplete: 'new-password',
      getRules: (originData) => {
        return originData.type !== undefined && originData.type === 'subscription-api'
          ? ''
          : 'required';
      },
      des: `
      此帳號取名需具特殊/唯一性、不必是可以收信的真實email、不可與 任何前台使用者帳號 或 其他工廠/集團系統管理員帳號 重複。
      建議可使用@esgoaladministrator.com做結尾較不容易發生重複，@前面可用客戶代號命名，例如：llgroup01@esgoaladministrator.com。
      此帳號作為工廠/集團初始登入使用並擁有最大權限，請妥善保管帳號密碼。
      `,
    },
    administrator_password: {
      label: '系統管理員密碼',
      type: 'password',
      autocomplete: 'new-password',
      getRules: (originData) => {
        return originData.type !== undefined && originData.type === 'subscription-api'
          ? ''
          : 'required';
      },
    },
    administrator_password_updated_at: {
      label: '系統管理員密碼更新時間',
      type: 'datetime',
      readonly: true,
    },
    chips: {
      type: 'custom',
      getValue(item) {
        if (!item.due_date) return null;
        const monthsUntilDue = Math.ceil(
          (new Date(item.due_date) - Date.now()) / (1000 * 60 * 60 * 24 * 30.44)
        );
        if (monthsUntilDue <= 0) {
          return [{
            text: '已到期',
            color: 'red',
            textColor: 'white',
            label: true,
          }];
        }
        if (monthsUntilDue <= 6) {
          return [{
            text: '近6個月內到期',
            color: 'red',
            textColor: 'white',
            label: true,
          }];
        }
        return null;
      },
    },
    type: {
      type: 'select',
      label: '訂閱類型管理',
      items: [
        {
          value: 'subscription-api',
          text: '訂閱API',
        },
      ]
    },
    subscription_api_modules: {
      type: 'multi-select',
      label: '訂閱API模組管理',
      items: [
        {
          value: 'act',
          text: '法規',
        },
      ],
      getRules: (originData) => originData.type && originData.type === "subscription-api" ? 'required' : '',
      displayCheck: (originData) => originData.type && originData.type === "subscription-api",
    },
    access_token: {
      type: 'text',
      label: '訂閱API Token',
      displayCheck: (modelData) => {
        const {type: subscriptionType} = modelData;
        return subscriptionType === 'subscription-api';
      }
    },
    subscription_topic: {
      type: 'belongsTo',
      label: '主題',
      textKey: 'name',
      modelName: 'topic',
      rules: 'required',
    },
    subscription_locales: {
      type: 'hasMany',
      label: '語言',
      modelName: 'locale',
    },
    is_image_viewable: {
      type: 'switch',
      label: '開放預覽圖片',
      defaultValue: true,
      activeText: '開放',
      inactiveText: '關閉',
    },
    map_url: {
      label: '適用地圖網站種類',
      type: 'select',
      items: [
        {
          text: 'google map',
          value: 'google',
        },
        {
          text: 'gaode map',
          value: 'gaode',
        },
        {
          text: 'naver map',
          value: 'naver',
        },
      ],
      defaultValue: 'google',
    },
    subscription_alliances: {
      type: 'hasMany',
      label: '聯盟',
      textKey: 'name',
      modelName: 'alliance',
      clearable: true,
    },
    is_alliance_home_page: {
      type: 'switch',
      label: '頻道列表為登入首頁',
      defaultValue: false,
      activeText: '是',
      inactiveText: '否',
    },
  },
};
